module.exports = __webpack_public_path__ + "static/media/trianon.7f39ddce.png";